import { useState } from "react";
import { format } from "date-fns";
import { CalendarDays } from "lucide-react";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const Field = ({ label, value, testid }) => (
  <div className="text-left" data-testid={testid}>
    <span className="block text-[11px] uppercase tracking-[0.18em] text-muted-foreground">{label}</span>
    <span className="block mt-1 text-sm">{value || "Add date"}</span>
  </div>
);

export const DateRangeSelect = ({ picker, months = 1 }) => {
  const { range, onSelect, disabled, hint } = picker;
  const [open, setOpen] = useState(false);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger className="grid grid-cols-2 gap-4 w-full border border-input rounded-md px-4 py-3 bg-white hover:border-[hsl(var(--sage))] transition-colors" aria-label="Choose check-in and check-out dates" data-testid="date-range-trigger">
        <Field label="Check-in" value={range?.from && format(range.from, "MMM d, yyyy")} testid="checkin-field" />
        <Field label="Check-out" value={range?.to && format(range.to, "MMM d, yyyy")} testid="checkout-field" />
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar mode="range" selected={range} defaultMonth={range?.from} onSelect={(r, day) => { onSelect(r, day); if (range?.from && !range.to && day > range.from) setOpen(false); }}
          disabled={disabled} numberOfMonths={months} data-testid="hero-calendar" />
        <p className="px-4 pb-3 text-xs text-muted-foreground flex items-center gap-1" data-testid="hero-calendar-hint"><CalendarDays className="w-3 h-3" /> {hint} Unavailable dates are crossed out.</p>
      </PopoverContent>
    </Popover>
  );
};

export const GuestSelect = ({ guests, setGuests, testid = "guest-select" }) => (
  <div>
    <label className="block text-[11px] uppercase tracking-[0.18em] text-muted-foreground mb-1" htmlFor={testid}>Guests</label>
    <Select value={String(guests)} onValueChange={(v) => setGuests(Number(v))}>
      <SelectTrigger id={testid} className="bg-white h-[58px]" data-testid={testid}><SelectValue /></SelectTrigger>
      <SelectContent>
        <SelectItem value="1" data-testid={`${testid}-1`}>1 guest</SelectItem>
        <SelectItem value="2" data-testid={`${testid}-2`}>2 guests</SelectItem>
      </SelectContent>
    </Select>
    <p className="text-[11px] text-muted-foreground mt-1">Maximum 2 guests</p>
  </div>
);
